import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    avatar: '',
    userName: '',
    email: '',
}

export const userSlice = createSlice({
	name: 'authentication/donor',
	initialState,
	reducers: {
        setDonor: (_, action) => action.payload,
        userLoggedOut: () => initialState,
	},
})

export const { setDonor } = userSlice.actions

export default userSlice.reducer